module.exports = global["Tether"] = require("-!/var/www/champgrand/themes/ZOneTheme/_dev/node_modules/babel-loader/lib/index.js!./tether.js");